import React, { Suspense, lazy } from 'react';
import { useSearchParams } from 'react-router';
import { TariffsVersionProvider, useTariffsVersion } from './context/TariffsVersionContext';

const TariffsModulePage = lazy(() =>
  import('./TariffsModulePage').then((m) => ({ default: m.TariffsModulePage })),
);

const TariffsMainPage = lazy(() =>
  import('./TariffsMainPage').then((m) => ({ default: m.TariffsMainPage })),
);

const ResolvedTariffsPage: React.FC = () => {
  const version = useTariffsVersion();
  const [params] = useSearchParams();

  /*
   * A link carrying a drill stack was minted BY the new module and only it can read one — the fee tab's "Analisar no
   * módulo", the fee drawer, a URL pasted into Slack. Honouring the reader's LEGACY preference there would open a screen
   * that silently ignores the whole point of the link, so the link wins for this navigation. It is not persisted: the
   * next plain visit to Tarifas still respects the preference.
   */
  const deepLink = params.has('drill');

  return version?.isLegacy && !deepLink ? <TariffsMainPage /> : <TariffsModulePage />;
};

/**
 * The single "Tarifas" entry point, resolving which module the user gets.
 *
 * Both modules used to be in the menu at once ("Tarifas" and "Tarifas 2"), which asked every user to guess which of
 * two screens over the same data was the real one. Now the rebuilt module is simply what Tarifas means, and the old one
 * is an opt-out kept until the sunset in {@link ./context/version.constants} — the same shape as the Posição de caixa
 * migration, down to the localStorage key and the Mixpanel property. There is no second path any more: `/tariffs` is
 * the only URL, for every user and every version.
 *
 * Both pages stay lazily loaded, so a user on one version never downloads the other.
 */
export const TariffsModuleRoute: React.FC = () => (
  <TariffsVersionProvider>
    <Suspense fallback={null}>
      <ResolvedTariffsPage />
    </Suspense>
  </TariffsVersionProvider>
);
